import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStatsCard = ({ stats }) => {
  const statItems = [
    {
      label: 'Available Days',
      value: stats?.availableDays,
      icon: 'Calendar',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Total Slots',
      value: stats?.totalSlots,
      icon: 'Clock',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Booked Slots',
      value: stats?.bookedSlots,
      icon: 'CheckCircle',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Blocked Days',
      value: stats?.blockedDays,
      icon: 'XCircle',
      color: 'text-error',
      bgColor: 'bg-error/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {statItems?.map((item, index) => (
        <div
          key={index}
          className="bg-card rounded-xl border border-border shadow-sm p-4 md:p-6 hover:shadow-md transition-all duration-250 ease-elegant"
        >
          <div className="flex items-start justify-between mb-3 md:mb-4">
            <div className={`w-10 h-10 md:w-12 md:h-12 ${item?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={item?.icon} size={20} className={item?.color} />
            </div>
          </div>
          <div>
            <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-1">
              {item?.value}
            </p>
            <p className="text-xs md:text-sm text-muted-foreground font-caption">
              {item?.label}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickStatsCard;